import React from "react";

// Dégradés de remplissage (variables du thème, index.css) :
//   - « or »   : paniers / unités ;
//   - « navy » : collecte en euros.
const REMPLISSAGES = {
  or: "linear-gradient(90deg, var(--trm-gold), var(--trm-gold-2))",
  navy: "linear-gradient(90deg, var(--trm-navy-surface), var(--trm-navy-surface-2))",
};

/**
 * Barre de progression d'une campagne. `pourcentage` peut dépasser 100
 * (objectif dépassé) : la barre s'arrête au bout, le texte garde le vrai
 * chiffre. Purement visuelle : le parent décide s'il y a une jauge ou non.
 *
 * Sortie de la page campagne pour servir aussi à la future story.
 */
export default function Jauge({ pourcentage, teinte = "navy" }) {
  const largeur = Math.max(0, Math.min(100, Number(pourcentage) || 0));
  return (
    <div className="h-2 bg-stone-100 rounded-full overflow-hidden" data-testid="jauge-campagne">
      <div className="h-full transition-all"
        style={{ width: `${largeur}%`, background: REMPLISSAGES[teinte] || REMPLISSAGES.navy }} />
    </div>
  );
}
